'use client';

import { styled } from '../../styles';
import { Divider } from '../Divider';
import { Typography } from '../Typography';

export const StyledDescriptionMobile = styled.div(
  () =>
    ({
      wordWrap: 'break-word',
    } as const),
);

export const DescriptionMobileLabel = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const DesciptionMobileDivider = styled(Divider)(({ theme }) => ({
  marginTop: theme.spacing(3),
}));

export const DescriptionMobileTip = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(1),
}));
